import { render, staticRenderFns } from "./siGoodsSearch.vue?vue&type=template&id=6d856a67&scoped=true&"
import script from "./siGoodsSearch.vue?vue&type=script&lang=js&"
export * from "./siGoodsSearch.vue?vue&type=script&lang=js&"
import style0 from "./siGoodsSearch.vue?vue&type=style&index=0&id=6d856a67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d856a67",
  null
  
)

component.options.__file = "siGoodsSearch.vue"
export default component.exports